import { Molecule, Atom } from "AppReact";
import styled, { css } from "styled-components";
import { TrashBinSvg } from 'components/icons';


const template = styled.div`
  ${({ displayState, theme }) => css`
    margin-left: 16px;
    cursor: pointer;
    svg {
      fill: ${window?.settings?.secondary_color ?? '#04333b'};
    }
    &:hover {
      svg {
        fill: #FD2020;
      }
    }
  `}
`;

const DeleteAtom = Atom({ type: 'button', dataType: 'object', template })


export default Molecule({
  template: styled.div``,
  atoms: [
    {
      component: DeleteAtom,
      name: 'Delete',
      displayValue: ({ width, height }) => TrashBinSvg({ width, height }),
      bindings: ({ resourceList, id }) => ({ resourceList: resourceList?.length ? resourceList : [], id })
    },
  ],
})
